import { Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { TableLazyLoadEvent } from 'primeng/table';
import { FilterInfo } from 'src/app/backend-client/models/Backend/Core/Api/Models/filter-info';
import { QueryRequest } from 'src/app/backend-client/models/Backend/Core/Api/Models/query-request';
import { MxMatchMode } from '.';

@Injectable({
  providedIn: 'root',
})
export class MxQueryService {
  constructor() {}

  static getQueryRequest(
    lazyLoadEvent: LazyLoadEvent | TableLazyLoadEvent | null,
    defaultSort: string,
    globalFilterColumns: string[],
    filterInfo: FilterInfo[] = []
  ): QueryRequest {
    const sortField = Array.isArray(lazyLoadEvent?.sortField)
      ? lazyLoadEvent?.sortField[0]
      : lazyLoadEvent?.sortField;

    return {
      skip: lazyLoadEvent ? lazyLoadEvent.first : 0,
      take: lazyLoadEvent ? lazyLoadEvent.rows : 0,
      filter: filterInfo,
      globalFilter: lazyLoadEvent.globalFilter
        ? globalFilterColumns.map((m) => {
            return {
              selector: m,
              matchMode: MxMatchMode.Contains,
              value: lazyLoadEvent.globalFilter,
            };
          })
        : null,
      defaultSort: defaultSort,
      sort: sortField
        ? [
            {
              desc: lazyLoadEvent.sortOrder === -1,
              selector: sortField,
            },
          ]
        : null,
    };
  }

  static getQueryResponseResult(result: any): {
    data: any[];
    totalRecords: number;
  } {
    return {
      data: result.items,
      totalRecords: result.recordCount,
    };
  }
}
